module.exports = __webpack_public_path__ + "static/media/2014_maleRate_femaleRate.5ae727ab.png";